import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { useLowQuotaBannerManagement } from "app/pages/sales-intelligence/modules/quota/hooks/useLowQuotaBannerManagement";
import { quotaKeys } from "app/pages/sales-intelligence/modules/quota/utils/i18n";

interface IProps {
    isAdmin: boolean;
    quota: number;
    hasPartialCredits: boolean;
}

const Content = ({ isAdmin, quota, hasPartialCredits }: IProps) => {
    const { translate } = useTranslate();
    const { lowCreditsBannerConfigs } = useLowQuotaBannerManagement();

    const getLowCreditsText = (): string => {
        if (isAdmin) {
            return translate(quotaKeys.lowCreditsText);
        }

        const { key, replacements } = quotaKeys.lowCreditsLeft({ quota });
        return translate(key, replacements);
    };

    const handleActionClick = (): void => {
        lowCreditsBannerConfigs.onClick?.();
    };

    const actionLabel = isAdmin ? translate(quotaKeys.quotaManageCredits) : translate(quotaKeys.quotaNotifyAdmin);

    return (
        <Stack
            gap="4px"
            data-automation="not-enough-quota-content"
        >
            <Text
                fontVariant="listItem4"
                color={colorsPalettes.bluegrey[100]}
            >
                {hasPartialCredits
                    ? translate(quotaKeys.insufficientCreditsTitle)
                    : translate(quotaKeys.lowCreditsQuestion)}
            </Text>

            <Text
                fontVariant="tooltip"
                color={colorsPalettes.bluegrey[100]}
            >
                {getLowCreditsText()}
            </Text>

            {lowCreditsBannerConfigs.onClick ? (
                <Text
                    cursor="pointer"
                    fontVariant="tooltip"
                    color={colorsPalettes.blue[300]}
                    onClick={handleActionClick}
                >
                    {actionLabel}
                </Text>
            ) : null}
        </Stack>
    );
};

export default Content;
